import api from '@/apis/di/budgetFeesAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Khoản
export const useBudgetFeesType2ComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // Lấy dữ liệu là phí
  const onBudgetFeesType2ComboboxLoadData = (payload, row, column) => {
    payload.sort = 'budget_fees_code';
    let extend = [
      { Field: 'inactive', Value: false },
      { Field: 'budget_fees_type', Value: 1 },
    ];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const budgetFeesType2ComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã phí, lệ phí',
        dataField: 'budget_fees_code',
        width: 200,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên phí, lệ phí',
        dataField: 'budget_fees_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 400,
      },
    ],
    displayField: 'budget_fees_name',
    valueField: 'budget_fees_id',
    queryMode: 'remote',
    quickSearch: 'BudgetFeesQuickSearch',
    quickSearchParam: {
      isFilter: true,
      filterFunc: x => x.inactive == false && x.budget_fees_type == 1,
    },
    dropdownWidth: 600,
    comboboxLoadData: onBudgetFeesType2ComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    budgetFeesType2ComboConfig,
    onBudgetFeesType2ComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
